var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import isObject from 'lodash/isObject';
import { XR } from '../index';
import { useEffect } from 'react';
import { createGlobalState } from '../store/createGlobalState';
var baseUnit = 4;
var fontSizeBase = 18;
var shared = {
    gap: baseUnit,
    gap2: 2 * baseUnit,
    gap4: 4 * baseUnit,
    borderRadius: 2 * baseUnit,
    font: {
        size1: fontSizeBase,
        sizeM1: fontSizeBase - 1 * 4,
        sizeM2: fontSizeBase - 2 * 4,
    },
};
var colors = {
    divider: 'rgba(127, 127, 127, 0.2)',
    error: 'rgba(239, 83, 80, 1)',
    success: 'rgba(26, 197, 103, 1)',
    warn: 'rgba(255, 181, 0, 1)',
};
var dark = __assign(__assign({}, shared), { color: __assign({ textPrimary: '#ffffff', textSecondary: '#99989e', opacityLayer: 'rgba(127, 127, 127, 0.2)' }, colors), component: {
        XRCard: {
            backgroundColor: '#1c1c1e',
            boxShadow: '0 2px 8px rgb(15, 15, 15)',
            borderRadius: shared.gap4,
        },
    } });
var light = __assign(__assign({}, shared), { color: __assign({ textPrimary: 'rgb(32, 34, 35)', textSecondary: '#717171', opacityLayer: 'rgba(127, 127, 127, 0.1)' }, colors), component: {
        XRCard: {
            backgroundColor: 'white',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 8px',
            borderRadius: shared.gap4,
        },
    } });
var themeColor = createGlobalState({
    id: 'XR.useTheme',
    autoSync: true,
});
export function useTheme() {
    var _a = themeColor.useState(), color = _a[0], setColor = _a[1];
    useEffect(function () {
        document.documentElement.setAttribute('theme', color);
        document.documentElement.removeAttribute('light');
        document.documentElement.removeAttribute('dark');
        document.documentElement.setAttribute(color, '1');
        localStorage.setItem('useTheme.color', color);
    }, [color]);
    return {
        var: color === 'light' ? light : dark,
        varDark: dark,
        varLight: light,
        color: color,
        toggle: function () {
            setColor(color === 'light' ? 'dark' : 'light');
        },
        setColor: function (color) {
            setColor(color);
        },
        useRegister: function (_color) {
            var _this = this;
            var style = {};
            useEffect(function () {
                if (color === undefined && _color) {
                    _this.setColor(_color);
                }
            }, [color, _color]);
            useEffect(function () {
                var _a;
                var element = document.createElement('style');
                element.innerHTML = "html { " + objectToVariables(style) + " }";
                (_a = document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.appendChild(element);
                return function () {
                    element.remove();
                };
            }, []);
        },
    };
}
function objectToVariables(style) {
    var variables = [];
    var extract = function (object, prefixes) {
        Object.keys(object).forEach(function (key) {
            var value = object[key];
            var prefixesNext = __spreadArray(__spreadArray([], prefixes), [key]);
            if (isObject(value)) {
                extract(value, prefixesNext);
            }
            else {
                variables.push(toVariable(value, prefixesNext));
            }
        });
    };
    extract(style, []);
    return variables.join(';');
}
function toVariable(value, prefixes) {
    value = XR.util.isNumber(value) ? value + "px" : value;
    return "--XR-" + prefixes.join('-') + ": " + value;
}
